export default __webpack_public_path__ + "static/media/download_red.c0c063ba.svg";